import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export class BadRequest {
  private _message = 'Http failure';

  constructor(public readonly error: HttpErrorResponse) {}

  public check(): boolean {
    const status = this.error.status === HttpStatusCode.BadRequest;
    const message = this.error.message.includes(this._message);

    return status && message;
  }
}
